<app-card
  class="flex-basis-100 mb-12"
  *ngIf="hasGeneralInfo(metadata) || hasGeneralInfo(originalMetadata)"
>
  <div cardTitle i18n>Informations générales</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata?.startDate | customDate) !==
                  (metadata.startDate | customDate),
            }"
            >{{ metadata.startDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata?.startDate | customDate) !==
                (metadata.startDate | customDate) &&
              (originalMetadata?.startDate | customDate) !== null &&
              (originalMetadata?.startDate | customDate) !== undefined
            "
            >{{ originalMetadata?.startDate | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDuration || originalMetadata?.contractDuration"
      >
        <span class="card__label" i18n>Durée du contrat</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.contractDuration !==
                  metadata.contractDuration,
            }"
            >{{ metadata.contractDuration }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.contractDuration !==
                metadata.contractDuration &&
              originalMetadata?.contractDuration !== null &&
              originalMetadata?.contractDuration !== undefined
            "
            >{{ originalMetadata?.contractDuration }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.paymentFrequency !== undefined &&
            metadata?.paymentFrequency !== null) ||
          (originalMetadata?.paymentFrequency !== undefined &&
            originalMetadata?.paymentFrequency !== null)
        "
      >
        <span class="card__label" i18n>Mode de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getPaymentFrequencyLabel(originalMetadata?.paymentFrequency) !==
                  getPaymentFrequencyLabel(metadata.paymentFrequency),
            }"
            >{{ getPaymentFrequencyLabel(metadata.paymentFrequency) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getPaymentFrequencyLabel(originalMetadata?.paymentFrequency) !==
                getPaymentFrequencyLabel(metadata.paymentFrequency) &&
              getPaymentFrequencyLabel(originalMetadata?.paymentFrequency) !==
                null &&
              getPaymentFrequencyLabel(originalMetadata?.paymentFrequency) !==
                undefined
            "
            >{{
              getPaymentFrequencyLabel(originalMetadata?.paymentFrequency)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.splitPaymentFee !== undefined &&
            metadata?.splitPaymentFee !== null) ||
          (originalMetadata?.splitPaymentFee !== undefined &&
            originalMetadata?.splitPaymentFee !== null)
        "
      >
        <span class="card__label" i18n
          >Supplément pour paiement fractionné</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.splitPaymentFee !== metadata.splitPaymentFee,
            }"
            >{{ metadata.splitPaymentFee }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.splitPaymentFee !== metadata.splitPaymentFee &&
              originalMetadata?.splitPaymentFee !== null &&
              originalMetadata?.splitPaymentFee !== undefined
            "
            >{{ originalMetadata?.splitPaymentFee }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasclaimsLastFiveYears !== null &&
            metadata?.hasclaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasclaimsLastFiveYears !== null &&
            originalMetadata?.hasclaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasclaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasclaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasclaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.hasclaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.claims || originalMetadata?.claims"
      >
        <span class="card__label" i18n>Détails des sinistres</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.claims !== metadata.claims,
            }"
            >{{ metadata.claims }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.claims !== metadata.claims &&
              originalMetadata?.claims !== null &&
              originalMetadata?.claims !== undefined
            "
            >{{ originalMetadata?.claims }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.categoryOne || originalMetadata?.categoryOne"
      >
        <span class="card__label" i18n>Catégorie 1</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.categoryOne !== metadata.categoryOne,
            }"
            >{{ metadata.categoryOne }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.categoryOne !== metadata.categoryOne &&
              originalMetadata?.categoryOne !== null &&
              originalMetadata?.categoryOne !== undefined
            "
            >{{ originalMetadata?.categoryOne }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.civilResponsability) ||
    !isSectionEmpty(originalMetadata?.civilResponsability)
  "
>
  <div cardTitle i18n>Responsabilité civile</div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="
      metadata?.civilResponsability || originalMetadata?.civilResponsability
    "
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.civilResponsability.civilResponsability !== null &&
            metadata.civilResponsability.civilResponsability !== undefined) ||
          (originalMetadata?.civilResponsability.civilResponsability !== null &&
            originalMetadata?.civilResponsability.civilResponsability !==
              undefined)
        "
      >
        <span class="card__label" i18n>Responsabilité civile</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.civilResponsability.civilResponsability
                ) !==
                  getBooleanLabel(
                    metadata.civilResponsability.civilResponsability
                  ),
            }"
            >{{
              getBooleanLabel(metadata.civilResponsability.civilResponsability)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.civilResponsability
              ) !==
                getBooleanLabel(
                  metadata.civilResponsability.civilResponsability
                ) &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.civilResponsability
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.civilResponsability
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.civilResponsability.civilResponsability
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.civilResponsability.bonusProtection !== null &&
            metadata.civilResponsability.bonusProtection !== undefined) ||
          (originalMetadata?.civilResponsability.bonusProtection !== null &&
            originalMetadata?.civilResponsability.bonusProtection !== undefined)
        "
      >
        <span class="card__label" i18n>Protection du bonus</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.civilResponsability.bonusProtection
                ) !==
                  getBooleanLabel(metadata.civilResponsability.bonusProtection),
            }"
            >{{
              getBooleanLabel(metadata.civilResponsability.bonusProtection)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.bonusProtection
              ) !==
                getBooleanLabel(metadata.civilResponsability.bonusProtection) &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.bonusProtection
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.bonusProtection
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.civilResponsability.bonusProtection
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.civilResponsability.seriousMisconductWaiver !== null &&
            metadata.civilResponsability.seriousMisconductWaiver !==
              undefined) ||
          (originalMetadata?.civilResponsability.seriousMisconductWaiver !==
            null &&
            originalMetadata?.civilResponsability.seriousMisconductWaiver !==
              undefined)
        "
      >
        <span class="card__label" i18n>Renonciation à la faute grave</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.civilResponsability.seriousMisconductWaiver
                ) !==
                  getBooleanLabel(
                    metadata.civilResponsability.seriousMisconductWaiver
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.civilResponsability.seriousMisconductWaiver
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.seriousMisconductWaiver
              ) !==
                getBooleanLabel(
                  metadata.civilResponsability.seriousMisconductWaiver
                ) &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.seriousMisconductWaiver
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.civilResponsability.seriousMisconductWaiver
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.civilResponsability.seriousMisconductWaiver
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.civilResponsability.deductible !== undefined &&
            metadata.civilResponsability.deductible !== null) ||
          (originalMetadata?.civilResponsability.deductible !== undefined &&
            originalMetadata?.civilResponsability.deductible !== null)
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.civilResponsability.deductible !==
                  metadata.civilResponsability.deductible,
            }"
            >{{ metadata.civilResponsability.deductible }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.civilResponsability.deductible !==
                metadata.civilResponsability.deductible &&
              originalMetadata?.civilResponsability.deductible !== null &&
              originalMetadata?.civilResponsability.deductible !== undefined
            "
            >{{ originalMetadata?.civilResponsability.deductible }} CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.casco) || !isSectionEmpty(originalMetadata?.casco)
  "
>
  <div cardTitle i18n>Casco</div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="metadata?.casco || originalMetadata?.casco"
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.cascoCollision !== null &&
            metadata.casco.cascoCollision !== undefined) ||
          (originalMetadata?.casco.cascoCollision !== null &&
            originalMetadata?.casco.cascoCollision !== undefined)
        "
      >
        <span class="card__label" i18n>Casco collision</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.casco.cascoCollision) !==
                  getBooleanLabel(metadata.casco.cascoCollision),
            }"
            >{{ getBooleanLabel(metadata.casco.cascoCollision) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.casco.cascoCollision) !==
                getBooleanLabel(metadata.casco.cascoCollision) &&
              getBooleanLabel(originalMetadata?.casco.cascoCollision) !==
                null &&
              getBooleanLabel(originalMetadata?.casco.cascoCollision) !==
                undefined
            "
            >{{ getBooleanLabel(originalMetadata?.casco.cascoCollision) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.bonusProtection !== null &&
            metadata.casco.bonusProtection !== undefined) ||
          (originalMetadata?.casco.bonusProtection !== null &&
            originalMetadata?.casco.bonusProtection !== undefined)
        "
      >
        <span class="card__label" i18n>Protection du bonus</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.casco.bonusProtection) !==
                  getBooleanLabel(metadata.casco.bonusProtection),
            }"
            >{{ getBooleanLabel(metadata.casco.bonusProtection) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.casco.bonusProtection) !==
                getBooleanLabel(metadata.casco.bonusProtection) &&
              getBooleanLabel(originalMetadata?.casco.bonusProtection) !==
                null &&
              getBooleanLabel(originalMetadata?.casco.bonusProtection) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.casco.bonusProtection)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.seriousMisconductWaiver !== null &&
            metadata.casco.seriousMisconductWaiver !== undefined) ||
          (originalMetadata?.casco.seriousMisconductWaiver !== null &&
            originalMetadata?.casco.seriousMisconductWaiver !== undefined)
        "
      >
        <span class="card__label" i18n>Renonciation à la faute grave</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.casco.seriousMisconductWaiver
                ) !== getBooleanLabel(metadata.casco.seriousMisconductWaiver),
            }"
            >{{ getBooleanLabel(metadata.casco.seriousMisconductWaiver) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.casco.seriousMisconductWaiver
              ) !== getBooleanLabel(metadata.casco.seriousMisconductWaiver) &&
              getBooleanLabel(
                originalMetadata?.casco.seriousMisconductWaiver
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.casco.seriousMisconductWaiver
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.casco.seriousMisconductWaiver)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.deductible !== undefined &&
            metadata.casco.deductible !== null) ||
          (originalMetadata?.casco.deductible !== undefined &&
            originalMetadata?.casco.deductible !== null)
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.casco.deductible !==
                  metadata.casco.deductible,
            }"
            >{{ metadata.casco.deductible }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.casco.deductible !==
                metadata.casco.deductible &&
              originalMetadata?.casco.deductible !== null &&
              originalMetadata?.casco.deductible !== undefined
            "
            >{{ originalMetadata?.casco.deductible }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.partialCasco !== null &&
            metadata.casco.partialCasco !== undefined) ||
          (originalMetadata?.casco.partialCasco !== null &&
            originalMetadata?.casco.partialCasco !== undefined)
        "
      >
        <span class="card__label" i18n>Casco partielle</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.casco.partialCasco) !==
                  getBooleanLabel(metadata.casco.partialCasco),
            }"
            >{{ getBooleanLabel(metadata.casco.partialCasco) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.casco.partialCasco) !==
                getBooleanLabel(metadata.casco.partialCasco) &&
              getBooleanLabel(originalMetadata?.casco.partialCasco) !== null &&
              getBooleanLabel(originalMetadata?.casco.partialCasco) !==
                undefined
            "
            >{{ getBooleanLabel(originalMetadata?.casco.partialCasco) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.theftDeductible !== undefined &&
            metadata.casco.theftDeductible !== null) ||
          (originalMetadata?.casco.theftDeductible !== undefined &&
            originalMetadata?.casco.theftDeductible !== null)
        "
      >
        <span class="card__label" i18n>Franchise en vol</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.casco.theftDeductible !==
                  metadata.casco.theftDeductible,
            }"
            >{{ metadata.casco.theftDeductible }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.casco.theftDeductible !==
                metadata.casco.theftDeductible &&
              originalMetadata?.casco.theftDeductible !== null &&
              originalMetadata?.casco.theftDeductible !== undefined
            "
            >{{ originalMetadata?.casco.theftDeductible }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.xenonLedHeadlightsCoverage !== null &&
            metadata.casco.xenonLedHeadlightsCoverage !== undefined) ||
          (originalMetadata?.casco.xenonLedHeadlightsCoverage !== null &&
            originalMetadata?.casco.xenonLedHeadlightsCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture des phares Xénon/LED</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.casco.xenonLedHeadlightsCoverage
                ) !==
                  getBooleanLabel(metadata.casco.xenonLedHeadlightsCoverage),
            }"
            >{{
              getBooleanLabel(metadata.casco.xenonLedHeadlightsCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.casco.xenonLedHeadlightsCoverage
              ) !==
                getBooleanLabel(metadata.casco.xenonLedHeadlightsCoverage) &&
              getBooleanLabel(
                originalMetadata?.casco.xenonLedHeadlightsCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.casco.xenonLedHeadlightsCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.casco.xenonLedHeadlightsCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.travelEffects !== undefined &&
            metadata.casco.travelEffects !== null) ||
          (originalMetadata?.casco.travelEffects !== undefined &&
            originalMetadata?.casco.travelEffects !== null)
        "
      >
        <span class="card__label" i18n>Effets de voyage</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.casco.travelEffects !==
                  metadata.casco.travelEffects,
            }"
            >{{ metadata.casco.travelEffects }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.casco.travelEffects !==
                metadata.casco.travelEffects &&
              originalMetadata?.casco.travelEffects !== null &&
              originalMetadata?.casco.travelEffects !== undefined
            "
            >{{ originalMetadata?.casco.travelEffects }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.swissEuAssistance !== null &&
            metadata.casco.swissEuAssistance !== undefined) ||
          (originalMetadata?.casco.swissEuAssistance !== null &&
            originalMetadata?.casco.swissEuAssistance !== undefined)
        "
      >
        <span class="card__label" i18n>Assistance en CH et/ou UE</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.casco.swissEuAssistance) !==
                  getBooleanLabel(metadata.casco.swissEuAssistance),
            }"
            >{{ getBooleanLabel(metadata.casco.swissEuAssistance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.casco.swissEuAssistance) !==
                getBooleanLabel(metadata.casco.swissEuAssistance) &&
              getBooleanLabel(originalMetadata?.casco.swissEuAssistance) !==
                null &&
              getBooleanLabel(originalMetadata?.casco.swissEuAssistance) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.casco.swissEuAssistance)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.replacementVehicle !== null &&
            metadata.casco.replacementVehicle !== undefined) ||
          (originalMetadata?.casco.replacementVehicle !== null &&
            originalMetadata?.casco.replacementVehicle !== undefined)
        "
      >
        <span class="card__label" i18n>Véhicule de remplacement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.casco.replacementVehicle) !==
                  getBooleanLabel(metadata.casco.replacementVehicle),
            }"
            >{{ getBooleanLabel(metadata.casco.replacementVehicle) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.casco.replacementVehicle) !==
                getBooleanLabel(metadata.casco.replacementVehicle) &&
              getBooleanLabel(originalMetadata?.casco.replacementVehicle) !==
                null &&
              getBooleanLabel(originalMetadata?.casco.replacementVehicle) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.casco.replacementVehicle)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.crossLiability !== null &&
            metadata.casco.crossLiability !== undefined) ||
          (originalMetadata?.casco.crossLiability !== null &&
            originalMetadata?.casco.crossLiability !== undefined)
        "
      >
        <span class="card__label" i18n>Cross Liability</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.casco.crossLiability) !==
                  getBooleanLabel(metadata.casco.crossLiability),
            }"
            >{{ getBooleanLabel(metadata.casco.crossLiability) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.casco.crossLiability) !==
                getBooleanLabel(metadata.casco.crossLiability) &&
              getBooleanLabel(originalMetadata?.casco.crossLiability) !==
                null &&
              getBooleanLabel(originalMetadata?.casco.crossLiability) !==
                undefined
            "
            >{{ getBooleanLabel(originalMetadata?.casco.crossLiability) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.partialCascoDeductible !== undefined &&
            metadata.casco.partialCascoDeductible !== null) ||
          (originalMetadata?.casco.partialCascoDeductible !== undefined &&
            originalMetadata?.casco.partialCascoDeductible !== null)
        "
      >
        <span class="card__label" i18n
          >Franchise générale en casco partiel</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.casco.partialCascoDeductible !==
                  metadata.casco.partialCascoDeductible,
            }"
            >{{ metadata.casco.partialCascoDeductible }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.casco.partialCascoDeductible !==
                metadata.casco.partialCascoDeductible &&
              originalMetadata?.casco.partialCascoDeductible !== null &&
              originalMetadata?.casco.partialCascoDeductible !== undefined
            "
            >{{ originalMetadata?.casco.partialCascoDeductible }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.cascoParc !== null &&
            metadata.casco.cascoParc !== undefined) ||
          (originalMetadata?.casco.cascoParc !== null &&
            originalMetadata?.casco.cascoParc !== undefined)
        "
      >
        <span class="card__label" i18n>Casco parc</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.casco.cascoParc) !==
                  getBooleanLabel(metadata.casco.cascoParc),
            }"
            >{{ getBooleanLabel(metadata.casco.cascoParc) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.casco.cascoParc) !==
                getBooleanLabel(metadata.casco.cascoParc) &&
              getBooleanLabel(originalMetadata?.casco.cascoParc) !== null &&
              getBooleanLabel(originalMetadata?.casco.cascoParc) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata?.casco.cascoParc) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.cascoParcDeductible !== undefined &&
            metadata.casco.cascoParcDeductible !== null) ||
          (originalMetadata?.casco.cascoParcDeductible !== undefined &&
            originalMetadata?.casco.cascoParcDeductible !== null)
        "
      >
        <span class="card__label" i18n>Franchise casco parc</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.casco.cascoParcDeductible !==
                  metadata.casco.cascoParcDeductible,
            }"
            >{{ metadata.casco.cascoParcDeductible }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.casco.cascoParcDeductible !==
                metadata.casco.cascoParcDeductible &&
              originalMetadata?.casco.cascoParcDeductible !== null &&
              originalMetadata?.casco.cascoParcDeductible !== undefined
            "
            >{{ originalMetadata?.casco.cascoParcDeductible }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.casco.bodyworkFreeChoice !== null &&
            metadata.casco.bodyworkFreeChoice !== undefined) ||
          (originalMetadata?.casco.bodyworkFreeChoice !== null &&
            originalMetadata?.casco.bodyworkFreeChoice !== undefined)
        "
      >
        <span class="card__label" i18n>Libre choix de la carrosserie</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata?.casco.bodyworkFreeChoice) !==
                  getBooleanLabel(metadata.casco.bodyworkFreeChoice),
            }"
            >{{ getBooleanLabel(metadata.casco.bodyworkFreeChoice) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata?.casco.bodyworkFreeChoice) !==
                getBooleanLabel(metadata.casco.bodyworkFreeChoice) &&
              getBooleanLabel(originalMetadata?.casco.bodyworkFreeChoice) !==
                null &&
              getBooleanLabel(originalMetadata?.casco.bodyworkFreeChoice) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata?.casco.bodyworkFreeChoice)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.occupantsAccidents) ||
    !isSectionEmpty(originalMetadata?.occupantsAccidents)
  "
>
  <div cardTitle i18n>Accidents des occupants</div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="metadata?.occupantsAccidents || originalMetadata?.occupantsAccidents"
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.occupantsAccidents.occupantsAccidents !== null &&
            metadata.occupantsAccidents.occupantsAccidents !== undefined) ||
          (originalMetadata?.occupantsAccidents.occupantsAccidents !== null &&
            originalMetadata?.occupantsAccidents.occupantsAccidents !==
              undefined)
        "
      >
        <span class="card__label" i18n>Accidents des occupants</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.occupantsAccidents.occupantsAccidents
                ) !==
                  getBooleanLabel(
                    metadata.occupantsAccidents.occupantsAccidents
                  ),
            }"
            >{{
              getBooleanLabel(metadata.occupantsAccidents.occupantsAccidents)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.occupantsAccidents.occupantsAccidents
              ) !==
                getBooleanLabel(
                  metadata.occupantsAccidents.occupantsAccidents
                ) &&
              getBooleanLabel(
                originalMetadata?.occupantsAccidents.occupantsAccidents
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.occupantsAccidents.occupantsAccidents
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.occupantsAccidents.occupantsAccidents
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.occupantsAccidents.deathBenefit !== undefined &&
            metadata.occupantsAccidents.deathBenefit !== null) ||
          (originalMetadata?.occupantsAccidents.deathBenefit !== undefined &&
            originalMetadata?.occupantsAccidents.deathBenefit !== null)
        "
      >
        <span class="card__label" i18n>Capital décès</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.occupantsAccidents.deathBenefit !==
                  metadata.occupantsAccidents.deathBenefit,
            }"
            >{{ metadata.occupantsAccidents.deathBenefit }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.occupantsAccidents.deathBenefit !==
                metadata.occupantsAccidents.deathBenefit &&
              originalMetadata?.occupantsAccidents.deathBenefit !== null &&
              originalMetadata?.occupantsAccidents.deathBenefit !== undefined
            "
            >{{ originalMetadata?.occupantsAccidents.deathBenefit }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.occupantsAccidents.disabilityCapital !== undefined &&
            metadata.occupantsAccidents.disabilityCapital !== null) ||
          (originalMetadata?.occupantsAccidents.disabilityCapital !==
            undefined &&
            originalMetadata?.occupantsAccidents.disabilityCapital !== null)
        "
      >
        <span class="card__label" i18n>Capital invalidité</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.occupantsAccidents.disabilityCapital !==
                  metadata.occupantsAccidents.disabilityCapital,
            }"
            >{{ metadata.occupantsAccidents.disabilityCapital }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.occupantsAccidents.disabilityCapital !==
                metadata.occupantsAccidents.disabilityCapital &&
              originalMetadata?.occupantsAccidents.disabilityCapital !== null &&
              originalMetadata?.occupantsAccidents.disabilityCapital !==
                undefined
            "
            >{{
              originalMetadata?.occupantsAccidents.disabilityCapital
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.occupantsAccidents.dailyAllowance !== undefined &&
            metadata.occupantsAccidents.dailyAllowance !== null) ||
          (originalMetadata?.occupantsAccidents.dailyAllowance !== undefined &&
            originalMetadata?.occupantsAccidents.dailyAllowance !== null)
        "
      >
        <span class="card__label" i18n>Indemnité journalière</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.occupantsAccidents.dailyAllowance !==
                  metadata.occupantsAccidents.dailyAllowance,
            }"
            >{{ metadata.occupantsAccidents.dailyAllowance }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.occupantsAccidents.dailyAllowance !==
                metadata.occupantsAccidents.dailyAllowance &&
              originalMetadata?.occupantsAccidents.dailyAllowance !== null &&
              originalMetadata?.occupantsAccidents.dailyAllowance !== undefined
            "
            >{{ originalMetadata?.occupantsAccidents.dailyAllowance }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.occupantsAccidents.hospitalisationAllowance !== undefined &&
            metadata.occupantsAccidents.hospitalisationAllowance !== null) ||
          (originalMetadata?.occupantsAccidents.hospitalisationAllowance !==
            undefined &&
            originalMetadata?.occupantsAccidents.hospitalisationAllowance !==
              null)
        "
      >
        <span class="card__label" i18n>Indemnité d'hospitalisation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.occupantsAccidents
                  .hospitalisationAllowance !==
                  metadata.occupantsAccidents.hospitalisationAllowance,
            }"
            >{{
              metadata.occupantsAccidents.hospitalisationAllowance
            }}
            CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.occupantsAccidents.hospitalisationAllowance !==
                metadata.occupantsAccidents.hospitalisationAllowance &&
              originalMetadata?.occupantsAccidents.hospitalisationAllowance !==
                null &&
              originalMetadata?.occupantsAccidents.hospitalisationAllowance !==
                undefined
            "
            >{{
              originalMetadata?.occupantsAccidents.hospitalisationAllowance
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.occupantsAccidents.unlimitedTreatmentFee !== null &&
            metadata.occupantsAccidents.unlimitedTreatmentFee !== undefined) ||
          (originalMetadata?.occupantsAccidents.unlimitedTreatmentFee !==
            null &&
            originalMetadata?.occupantsAccidents.unlimitedTreatmentFee !==
              undefined)
        "
      >
        <span class="card__label" i18n>Frais de traitement illimités</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata?.occupantsAccidents.unlimitedTreatmentFee
                ) !==
                  getBooleanLabel(
                    metadata.occupantsAccidents.unlimitedTreatmentFee
                  ),
            }"
            >{{
              getBooleanLabel(metadata.occupantsAccidents.unlimitedTreatmentFee)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata?.occupantsAccidents.unlimitedTreatmentFee
              ) !==
                getBooleanLabel(
                  metadata.occupantsAccidents.unlimitedTreatmentFee
                ) &&
              getBooleanLabel(
                originalMetadata?.occupantsAccidents.unlimitedTreatmentFee
              ) !== null &&
              getBooleanLabel(
                originalMetadata?.occupantsAccidents.unlimitedTreatmentFee
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata?.occupantsAccidents.unlimitedTreatmentFee
              )
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
